import { PaginationT } from 'models/Pagination'
import { api } from '../index'

// Transformed shape used by the UI
export interface UserListCampaign {
  id: number
  name: string
  type: string
  state: string
  createdAt: string
  createdBy: string | undefined
}

// Raw shape from the CampaignEntity API response
interface RawCampaign {
  id: number
  name: string
  type: string
  state: string
  created_at: string
  creator?: {
    first_name: string
    last_name: string
  } | null
}

interface GetCampaignsResponse {
  campaigns: RawCampaign[]
  pagination: PaginationT
}

interface GetCampaignsParams {
  userListId: number
  page?: number
  per_page?: number
  state?: string
}

export const userListCampaignsApi = api.injectEndpoints({
  endpoints: builder => ({
    getUserListCampaigns: builder.query<
      { data: UserListCampaign[]; pagination: PaginationT },
      GetCampaignsParams
    >({
      query: ({ userListId, ...params }) => ({
        url: `user_lists/${userListId}/campaigns`,
        method: 'GET',
        params,
      }),
      transformResponse: (response: GetCampaignsResponse) => ({
        data: (response.campaigns || []).map(c => ({
          id: c.id,
          name: c.name,
          type: c.type,
          state: c.state,
          createdAt: c.created_at,
          createdBy: c.creator
            ? `${c.creator.first_name} ${c.creator.last_name}`.trim()
            : undefined,
        })),
        pagination: response.pagination,
      }),
      providesTags: (_result, _error, { userListId }) => [
        { type: 'UserList', id: `${userListId}-campaigns` },
      ],
    }),
  }),
})

export const { useGetUserListCampaignsQuery } = userListCampaignsApi
